import type { IDateFilterParams } from '@mint-lib/ag-grid/community';

export const dateFilterParams: IDateFilterParams = {
  comparator: (filterLocalDateAtMidnight: Date, cellValue: string) => {
    if (cellValue == null) return -1;

    const fullDate = new Date(cellValue);

    const dateOnly = new Date(
      fullDate.getFullYear(),
      fullDate.getMonth(),
      fullDate.getDate(),
    );

    if (dateOnly < filterLocalDateAtMidnight) {
      return -1;
    } else if (dateOnly > filterLocalDateAtMidnight) {
      return 1;
    }
    return 0;
  },
  closeOnApply: true,
  buttons: ['apply', 'reset'],
  // No upper bound: a hard-coded year turns every later date into an invalid
  // filter once that year is over.
  minValidYear: 2000,
};
